<div class="d-flex flex-column gap-1 mb-3">
  <div class="history-detail">{{ description }}</div>
  <div class="history-timestamp">
    {{ date | dateStringWithAt }}
  </div>
</div>
